import axiosBackEnd from "../config/axios/axios-back-end";

const getHotelById = async (id) => {
  const res = await axiosBackEnd.get(`/api/hotels/${id}`);
  return res.data;
};

const getHotels = async () => {
  const res = await axiosBackEnd.get(`/api/hotels`);
  return res.data;
};

const updateHotelReview = async (data) => {
  const id = data?._id;
  const res = await axiosBackEnd.put(`/api/hotels/${id}/review`, data);
  return res.data;
};

// const getHotelReports = async (id) => {
//   const res = await axiosBackEnd.get(`/api/hotels/${id}/reports`);
//   return res.data;
// };

/**
 * 
 * @description all hotel list with mandatory fields
 */
const getHotelList = async () => {
  const res = await axiosBackEnd.get("/api/hotels/list");
  return res.data?.data ?? [];
};

const getProjectHotelReports = async (projectId, hotelId) => {
  const res = await axiosBackEnd.get(
    `/api/projects/${projectId}/hotels/${hotelId}/reports`,
  );
  return res.data;
};

const replicateHotelReports = async (data) => {
  const { projectId, sourceHotelId, destinationHotelId } = data;
  const response = await axiosBackEnd.post(
    `/api/projects/${projectId}/hotels/${sourceHotelId}/reports/replicate/${destinationHotelId}`,
  );
  return response.data;
};

export {
  getHotels,
  getHotelList,
  updateHotelReview,
  // getHotelReports,
  getHotelById,
  getProjectHotelReports,
  replicateHotelReports,
};
